import { ViewedJobsModal } from "@spa/features/viewed/pc/components/ViewedJobsModal";
import RecentSearchesModal from "@spa/features/recent_searches/pc/components/RecentSearchesModal";
import React, { useEffect } from 'react';
import {usePage} from "@inertiajs/react";
import {mix} from "@spa/utils/assetPathResolver";
import {initBiggerLink} from "@design/pc/modules/biggerLink";
import FilterWrapper from "@spa/features/search_job/pc/components/FilterWrapper";
import SearchForm from "@spa/features/search_job/pc/components/SearchForm";

const Header = (props) => {
    const { route, translations } = usePage().props;

    useEffect(() => {
        initBiggerLink(); // 閲覧履歴のパネルで使用
    }, []);

    return (
        <header className="l-h">
            <div className="l-h_wrap">
                <div className="l-h_upperHead">
                    <div className="l-h_propHeadArea">
                        <p className="l-h_property"><a href={route.web.top} className="c-text_link">{translations.job_search}</a></p>
                        {props.h1 && <h1 className="l-h_ttl">{props.h1}</h1>}
                    </div>

                    <ul className="l-h_usermenu">
                        <li className="l-h_usermenu_item">
                            <a href={route.web.saved} className="l-h_usermenu_link l-h_usermenu_link--saved" rel="nofollow">
                                {translations.saved}
                            </a>
                            {props.savedJobsCount > 0 && (
                                <span className="c-badge u-ml5 u-fw_b s-saved_jobs_count">{props.savedJobsCount}</span>
                            )}
                        </li>
                        <li className="l-h_usermenu_item">
                            <button className="l-h_usermenu_link l-h_usermenu_link--history s-headerModal s-headerBtn--viewedJobs">
                                {translations.viewed_jobs}
                            </button>
                            <div className="p-header_balloon_wrap s-header_balloon s-header_balloon--viewedJobs"
                                data-modal="viewedJobs">
                                <ViewedJobsModal
                                    modalViewModel={props.modalViewModel}
                                />
                            </div>
                        </li>
                        <li className="l-h_usermenu_item">
                            <button
                                className="l-h_usermenu_link l-h_usermenu_link--search s-headerModal s-headerBtn--recentSearches">
                                {translations.recent_searches}
                            </button>
                            <div className="p-header_balloon_wrap s-header_balloon s-header_balloon--recentSearches"
                                data-modal="recentSearches">
                                <RecentSearchesModal
                                    modalViewModel={props.modalViewModel}
                                />
                            </div>
                        </li>
                    </ul>
                </div>

                <div className="l-h_bottomHead">
                    <div className="l-h_siteTtl">
                        <a href={route.web.top} className="l-h_siteTtl_logo" tabIndex="1">
                            <img src={mix('webfront/images/logo.svg')} width="180" height="33" alt="Jobcube"/>
                        </a>
                    </div>

                    {props.hasSearchWindow && <SearchForm/>}
                </div>
                <div className="p-filter_wrap u-mt20">
                    {props.hasSearchWindow && (
                        <FilterWrapper
                            narrowSearchParamsViewModel={props.narrowSearchParamsViewModel}
                            searchResultViewModel={props.searchResultViewModel}
                        />
                    )}
                </div>
            </div>
        </header>
    );
}

export default Header;

